import React, { useState } from "react";
import InternalMessage from "./InternalMessage";
import ExternalMessage from "./ExternalMessage";
import "./Messages.scss";

interface NOTES {
  notesData: any;
  fetchingNotes: any;
}

const Messages: React.FC<NOTES> = ({ notesData, fetchingNotes }) => {
  const [radioValue, setRadioValue] = useState("Internal Notes");
  const [showCompose, setShowCompose] = useState(false);

  const notesButton = ["Internal Notes", "External Notes"];

  const buttonChangeHandler = (value: string) => {
    setRadioValue(value);
    setShowCompose(false);
  };

  return (
    <div className="messages-container">
      <div className="messages-card card">
        <div className="messages-header">
          <div className="tabs-container">
            {notesButton.map((el: string) => (
              <button
                key={el}
                className={`tab-button ${radioValue === el ? "active" : ""}`}
                onClick={() => buttonChangeHandler(el)}
              >
                {el}
              </button>
            ))}
          </div>

          <button
            className="add-note-btn"
            onClick={() => setShowCompose(!showCompose)}
          >
            <span>+</span>
            <span>Add Note</span>
          </button>
        </div>

        <div className="messages-body">
          {radioValue === "External Notes" ? (
            <ExternalMessage
              customerNotes={notesData?.customer_notes}
              fetchingNotes={fetchingNotes}
              showCompose={showCompose}
              setShowCompose={setShowCompose}
            />
          ) : (
            <InternalMessage
              internalNotes={notesData?.internal_notes}
              fetchingNotes={fetchingNotes}
              showCompose={showCompose}
              setShowCompose={setShowCompose}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Messages;